import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { SalesSummary } from "src/app/shared/models/focusDataModels/SalesSummary";

@Component({
	selector: "app-daily-sales-report-chart-header",
	templateUrl: "./daily-sales-report-chart-header.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class DailySalesReportChartHeaderComponent implements OnInit, OnChanges {
	@Input() salesSummary: SalesSummary;
	@Output() salesSummaryChange = new EventEmitter<SalesSummary>();

	@Input() loading: boolean;
	@Output() loadingChange = new EventEmitter<boolean>();

	cardColor: string = "#FFFFFF";

	numberChartData: { name: string; value: number }[] = [];

	gaugeChartData: { name: string; value: number }[] = [];
	chartMaxValue: number = 0;

	legend: boolean = false;
	legendPosition: string = "below";
	colorScheme = { domain: ["#5AA454", "#E44D25", "#CFC0BB", "#7aa3e5", "#a8385d", "#aae3f5"] };
	constructor(public app: AppService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.salesSummary) {
			this.gaugeChartData = [];
			this.numberChartData = [];
			this.initChart();
		}
	}

	ngOnInit(): void {}

	initChart() {
		let highestValue = 0;
		this.numberChartData.push({
			name: "Net Sales",
			value: this.salesSummary.NetSales,
		});

		this.numberChartData.push({
			name: "Gross Sales",
			value: this.salesSummary.NetSales + +this.salesSummary.DiscountAmount,
		});

		this.gaugeChartData.push({
			name: "Sales",
			value: +this.salesSummary.NetSales,
		});
		this.gaugeChartData.push({
			name: "Same day last year",
			value: +(this.salesSummary.NetSales * 1.234),
		});
		this.gaugeChartData.push({
			name: "Same day last week",
			value: +(this.salesSummary.NetSales * 0.98),
		});
		this.gaugeChartData.push({
			name: `Average ${this.app.moment().format("dddd")}`,
			value: +(this.salesSummary.NetSales * 1.2),
		});
		this.gaugeChartData.forEach((i) => {
			if (i.value > highestValue) {
				highestValue = i.value;
			}
		});
		this.chartMaxValue = highestValue;
	}
}
